import { render } from "./MakeNominationInstruction.vue?vue&type=template&id=7935af1a&scoped=true"
import script from "./MakeNominationInstruction.vue?vue&type=script&lang=js"
export * from "./MakeNominationInstruction.vue?vue&type=script&lang=js"

import "./MakeNominationInstruction.vue?vue&type=style&index=0&id=7935af1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7935af1a"]])

export default __exports__